import React from 'react';
import { getStatusLabel, getStatusColor } from '../services/projectsAPI';

/**
 * 專案狀態徽章元件
 * @param {Object} props
 * @param {string} props.status - 專案狀態
 * @param {string} props.className - 額外的 CSS 類別
 */
function ProjectStatusBadge({ status, className = '' }) {
  const label = getStatusLabel(status);
  const color = getStatusColor(status);

  const colorClasses = {
    gray: 'bg-gray-100 text-gray-800 border-gray-300',
    blue: 'bg-blue-100 text-blue-800 border-blue-300',
    green: 'bg-green-100 text-green-800 border-green-300',
    yellow: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    teal: 'bg-teal-100 text-teal-800 border-teal-300',
    red: 'bg-red-100 text-red-800 border-red-300',
  };

  const colorClass = colorClasses[color] || colorClasses.gray;

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${colorClass} ${className}`}
    >
      {label}
    </span>
  );
}

export default ProjectStatusBadge;
